export const QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_ACTION =
    "@QUOTATION_POPUP/VALIDATE_DOCUMENT_NUMBER";
export const QUOTATION_POPUP_VALIDATE_DOCUMENT_NUMBER_DONE_ACTION =
    "@QUOTATION_POPUP/VALIDATE_DOCUMENT_NUMBER_DONE";
export const QUOTATION_POPUP_SUBMIT_FORM = "@QUOTATION_POPUP/SUBMIT_FORM";
export const QUOTATION_POPUP_SUBMIT_FORM_DONE =
    "@QUOTATION_POPUP/SUBMIT_FORM_DONE";
export const QUOTATION_POPUP_RESET_FORM = "@QUOTATION_POPUP/RESET_FORM";
export const QUOTATION_POPUP_SET_CUSTOMER_ALREADY_HAS_POLICY_POPUP_OPENED =
    "@QUOTATION_POPUP/SET_CUSTOMER_ALREADY_HAS_POLICY_POPUP_OPENED";
export const QUOTATION_POPUP_SET_CANNOT_OFFER_THIS_PRODUCT_POPUP_OPENED =
    "@QUOTATION_POPUP/SET_CANNOT_OFFER_THIS_PRODUCT_POPUP_OPENED";
